(() => {
  const init = (root) => {
    if (root.dataset.rfReady) return;
    root.dataset.rfReady = 'true';

    const picker = root.querySelector('[data-rf-picker]');
    const panels = root.querySelectorAll('[data-rf-panel]');
    let lastTile = null;

    // Slider, die versteckt geladen wurden, im sichtbaren Zustand neu aufbauen
    // (iOS Safari macht sonst den Scrollbereich nicht wischbar).
    const rebuildSliders = (scope) => {
      scope.querySelectorAll('css-slider').forEach((slider) => {
        if (typeof slider.destroySlider === 'function' && typeof slider.initSlider === 'function') {
          slider.destroySlider();
          slider.initSlider();
        }
      });
    };

    const open = (tile) => {
      const panel = root.querySelector('#' + CSS.escape(tile.dataset.rfOpen));
      if (!panel) return;
      lastTile = tile;
      panels.forEach((p) => { p.hidden = p !== panel; });
      root.querySelectorAll('[data-rf-open]').forEach((t) => t.setAttribute('aria-expanded', String(t === tile)));
      picker.hidden = true;
      root.classList.add('is-open');
      rebuildSliders(panel);
      const focusTarget = panel.querySelector('[data-rf-focus]');
      if (focusTarget) focusTarget.focus({ preventScroll: true });
      const top = root.getBoundingClientRect().top + window.scrollY - 120;
      if (root.getBoundingClientRect().top < 80) window.scrollTo({ top, behavior: 'smooth' });
    };

    const close = () => {
      panels.forEach((p) => { p.hidden = true; });
      root.querySelectorAll('[data-rf-open]').forEach((t) => t.setAttribute('aria-expanded', 'false'));
      picker.hidden = false;
      root.classList.remove('is-open');
      rebuildSliders(picker);
      if (lastTile) lastTile.focus({ preventScroll: true });
    };

    root.addEventListener('click', (event) => {
      const tile = event.target.closest('[data-rf-open]');
      if (tile && root.contains(tile)) { open(tile); return; }
      if (event.target.closest('[data-rf-back]')) close();
    });

    root.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && root.classList.contains('is-open')) close();
    });
  };

  const run = () => document.querySelectorAll('[data-terjung-rezept-finder]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();
  document.addEventListener('shopify:section:load', run);
})();
